// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --cart-bannder-height: 100px;
    --cart-card-height: 66px;
    --single-row-height: 69px;
    --add-row-section-height: 45px;

    --place-order-assign-body-content-height: 35vh;
    --place-order-confirmation-page-content-padding: 24px;
}

/* ---- Header ---- */
.cart-header-start-section {
    min-height: var(--cart-bannder-height);
    background: var(--neutral-color2) 0% 0% no-repeat padding-box;
    color: var(--neutral-color1);
    width: 100%;
}

.wrapper-cart-header-section {
    width: 100%;
    min-height: var(--cart-bannder-height);
    padding: var(--body-header-padding);
    padding-bottom: 0;
}

.wrapper-cart-header-section .breadcrumb .custome-path-active-tab,
.wrapper-cart-header-section .breadcrumb .custome-path-active-tab::before {
    color: var(--neutral-color6);
}

.cart-header-nav-section {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    align-items: center;
    border-bottom: 1px solid #CCCCCC;
}

.cart-header-nav-section .cart-header-nav-item-section {
    font: normal normal 22px/27px Lato;
    letter-spacing: 0.22px;
    color: #333333;

}

.cart-header-nav-section .cart-header-nav-item-section:first-child svg {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.cart-header-nav-section .cart-header-nav-item-section:nth-child(2) {
    display: grid;
    justify-items: center;
}

.cart-header-nav-section .cart-header-nav-item-section:nth-child(2) .nav-responsive-2 {
    max-width: 420px;
}

.cart-header-nav-item-section .nav-responsive-2 .nav-link {
    font: normal normal 18px/22px Lato;
    letter-spacing: 0.18px;
    color: #999999;
}

.cart-header-nav-item-section .nav-responsive-2 .active {
    color: #333333;
}

.cart-header-nav-item-section .nav-responsive-2 .nav-link .nav-link-notification-section {
    min-width: 28px;
    height: 28px;
    padding: 0 6px;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border: 1px solid var(--call-to-action1);
    transition: all 0.5s;
    display: grid;
    align-items: center;
    justify-items: center;
    border-radius: 50%;
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0px;
    color: var(--call-to-action1);
}

.cart-header-nav-item-section .nav-responsive-2 .active .nav-link-notification-section {
    transition: all 0.5s;
    border: 0;
    background: #009DE0 0% 0% no-repeat padding-box;
    color: var(--neutral-color1);
}

/* ------------------------ Content Section ----------------------- */
.cart-return-drop-down-section {
    padding: 15px 0;
    border-bottom: 1px solid var(--neutral-color4);
    background: var(--bg-while-blue) 0% 0% no-repeat padding-box;
    display: grid;
    grid-template-columns: 0.5fr 1.2fr 0.5fr;
}

.cart-return-drop-down-section .cart-return-drop-down-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 10px;
}

.cart-return-drop-down-section .cart-return-drop-down-item-section:nth-child(2) .card-item-group .custom-drop-down-form-group {
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border-radius: 6px;
}

.cart-select-all-item-section {
    font: normal normal 14px/15px Lato;
    letter-spacing: 0.14px;
    color: var(--call-to-action1);
    cursor: pointer;
    transition: all 0.5s;
}

.cart-select-all-item-section:hover {
    color: var(--call-to-action2);
    transition: all 0.5s;
}

/* ---------------- Card Section ---------------- */
/* -------- Request stock Card Section -------- */
.request-stock-card-section {
    min-height: var(--cart-card-height);
    width: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    padding: 9px 14px 9px 24px;
    transition: all 0.5s;
}

.request-stock-card-section:hover {
    transform: scale(1.012);
    transition: all 0.5s;
}

.wrapper-request-stock-card-section {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 5fr 0.4fr;
    grid-column-gap: 20px;
    align-items: center;
}

.wrapper-request-stock-card-section .normal-card-item-section:first-child {
    display: grid;
    grid-template-columns: 0.2fr 1fr;
    align-items: center;
    border-right: 1px solid #E6E6E6;
    height: 100%;
}

.wrapper-request-stock-card-section .normal-card-item-section:first-child .card-item-value {
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0.18px;
    color: #009BDF;
}

.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: 2fr repeat(3, 0.8fr) 1fr;
}

.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .normal-card-item-qnt-title {
    font: normal normal 12px/18px Lato;
    letter-spacing: 0.12px;
    color: #4D4D4D;
    text-align: center
}

.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
}

.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-input {
    width: 100%;
    min-height: 28px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #999999;
    text-align: center;
    font: normal normal bold 14px/15px Lato;
    letter-spacing: 0.14px;
    color: #000000;
}

.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn {
    width: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #999999;
    border-radius: 4px 0px 0px 4px;
    display: grid;
    align-items: center;
    justify-items: center;
    cursor: pointer;
}

.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn:first-child {
    border-right: 0;
}

.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn:last-child {
    border-radius: 0px 4px 4px 0px;
    border-left: 0;
}

.wrapper-request-stock-card-section .normal-card-item-section:last-child {
    border-left: 1px solid #E6E6E6;
    height: 100%;
    display: grid;
    align-items: center;
    justify-items: center;
    cursor: pointer;
}

/* -------- Return stock Card Section -------- */
/* .return-stock-details-section{
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s cu;
}
.return-stock-details-section-show{
    height: auto;
    max-height: 9999px;
    transition: all 1s;
} */
.return-stock-card-section {
    min-height: var(--cart-card-height);
    width: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;

    border-radius: 6px;
    box-shadow: 0px 0px 6px #00000029;
    transition: all 0.5s;
    display: grid;
}

.return-stock-card-section:hover {
    transform: scale(1.012);
    transition: all 0.5s;
}

.wrapper-return-stock-card-section {
    padding: 9px 14px 9px 24px;
    box-shadow: 0px 0px 6px #00000029;
    width: 100%;
    min-height: var(--cart-card-height);
    display: grid;
    grid-template-columns: 1fr 5fr 1.7fr;
    grid-column-gap: 20px;
    align-items: center;
}

.wrapper-return-stock-card-section .normal-card-item-section:first-child {
    display: grid;
    grid-template-columns: 0.2fr 1fr;
    align-items: center;
    border-right: 1px solid #E6E6E6;
    height: 100%;
}

.wrapper-return-stock-card-section .normal-card-item-section:first-child .card-item-value {
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0.18px;
    color: #009BDF;
}

.wrapper-return-stock-card-section .normal-card-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: 2fr repeat(3, 0.8fr);
    grid-column-gap: 5px;
}


.wrapper-return-stock-card-section .normal-card-item-section:last-child {
    display: grid;
    grid-template-columns: 1.8fr 0.4fr;
    align-items: center;
    justify-items: center;
    height: 100%;
    grid-column-gap: 3px;
}

.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group {
    height: 100%;
    width: 100%;
    display: grid;
    align-items: center;
    transition: all 0.2s;
    text-align: end;
    font: normal normal bold 14px/18px Lato;
    letter-spacing: 0.14px;
    color: var(--call-to-action1);
}

.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group span {
    align-items: center;
    color: var(--indicators-red);
}


.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child {
    border-right: 1px solid #E6E6E6;
    border-left: 1px solid #E6E6E6;
    display: grid;
    cursor: pointer;
}

.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child .card-item-inner {
    text-align: center;
}

.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child svg {
    width: 14px;
    height: 14px;
    margin-left: 10px;
}

.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:last-child {
    justify-items: center;
}

.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child:hover {
    color: var(--call-to-action2);
}

.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child:hover svg line {
    stroke: var(--call-to-action2);
}

.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:last-child:hover svg path {
    fill: var(--call-to-action2);
}




/* -------- Return stock Card Details Section -------- */
.wrapper-return-stock-details-card-section {
    min-height: var(--single-row-height);
    width: 100%;
}

.wrapper-return-stock-details-card-section .return-stock-card-row-section {
    padding: 8px 20px;
    min-height: var(--single-row-height);
    display: grid;
    grid-template-columns: 0.2fr 1fr 1fr 1fr 0.2fr;
    grid-column-gap: 10px;
    align-items: center;
    justify-items: center;
}

.wrapper-return-stock-details-card-section .return-stock-card-row-section .card-row-group {
    width: 100%;
    height: 100%;
}

.wrapper-return-stock-details-card-section .return-stock-card-row-section .card-row-group:first-child,
.wrapper-return-stock-details-card-section .return-stock-card-row-section .card-row-group:last-child {
    display: grid;
    align-items: center;
    justify-items: center;
    width: 100%;
    height: 100%;
}

.wrapper-return-stock-details-card-section .return-stock-card-row-section .card-row-group:first-child {
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0.14px;
    color: var(--neutral-color7);
}

.card-row-group .custom-drop-down-form-group {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 6px;
}

.wrapper-return-stock-details-card-section .return-stock-card-row-section:nth-child(odd) {
    background: #F3F3F3 0% 0% no-repeat padding-box;
}

.add-row-section {
    min-height: var(--add-row-section-height);
    width: 100%;
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--call-to-action1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.5s;
}

.add-row-section svg {
    margin-left: 10px;
}

.add-row-section:hover,
.add-row-section:hover svg #Group_8724 line,
.add-row-section:hover svg #Ellipse_1157 {
    color: var(--call-to-action2);
    stroke: var(--call-to-action2);
    transition: all 0.5s;
}

.cart-place-order-section {
    position: fixed;
    bottom: 0;
    min-height: 82px;
    width: 100%;
    transition: var(--deault-transition);
    z-index: 1;
}

.wrapper-cart-place-order-section {
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px -6px 20px var(--border-shadow-color2);
    font: normal normal normal 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color7);
    padding: 15px 24px;
    display: grid;
    align-items: center;
    grid-template-columns: 3fr 1fr;
}

.wrapper-cart-place-order-section .cart-place-order-item-group:first-child span {
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0.18px;
}

.wrapper-cart-place-order-section .cart-place-order-item-group:last-child {
    display: grid;
    justify-content: flex-end;
}

.cart-return-place-order-section .cart-msg-validation {
    font: normal normal normal 16px/19px Lato;
    text-align: center;
    letter-spacing: 0.16px;
    color: #F44236;
}

/* -------------- Add Serial Number Modal ---------------- */
.add-serial-number-modal .modal-dialog {
    max-width: 70%;
    margin-top: 8%;
}

.add-serial-number-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}

.add-serial-number-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-color4);
}

.add-serial-number-modal .modal-header-title-section {
    grid-template-columns: 1fr;
    grid-row-gap: 5px;
}

.add-serial-number-modal .modal-header-title-section .modal-header-group-section:first-child {
    display: flex;
    width: 100%;
    align-items: center;
}

.add-serial-number-modal .modal-header-title-section .modal-header-group-section:first-child span {
    margin-left: 15px;
    font: normal normal bold 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color5);
}

.add-serial-number-modal .modal-header-title-section .modal-header-group-section:last-child {
    display: grid;
    grid-template-columns: 1fr 0.5fr;
}

.add-serial-number-modal .modal-header-title-section .modal-header-group-section:last-child .modal-header-group-item:first-child {
    font: normal normal 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--text-color1);
}

.add-serial-number-modal .modal-header-title-section .modal-header-group-section:last-child .modal-header-group-item:first-child span {
    font-weight: bold;
    color: var(--text-color2);
}

.add-serial-number-modal .modal-header-title-section .modal-header-group-section:last-child .modal-header-group-item:last-child {
    display: flex;
    justify-content: flex-end;
}

.add-serial-number-modal .modal-body {
    min-height: 260px;
    max-height: 350px;
    padding-top: 0;
    margin-top: 0;
}

.add-serial-number-modal .modal-body .wrapper-modal-body {
    width: 100%;
    height: 100%;
    display: grid;
    grid-row-gap: 0;
}

.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group {
    display: grid;
    grid-template-columns: 0.1fr 0.8fr 0.1fr;
    grid-column-gap: 10px;
    padding: 10px 0;
}

.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group:nth-child(odd) {
    background: var(--neutral-color2) 0% 0% no-repeat padding-box;
}

.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group .modal-body-group-item {
    display: grid;
    justify-items: center;
    align-items: center;
}

.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group .modal-body-group-item:nth-child(2) .custom-input-form-group {
    width: 100%;
}

.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group .modal-body-group-item:last-child {
    cursor: pointer;
}

.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group .modal-body-group-item:last-child:hover svg path {
    fill: var(--call-to-action2);
    transition: all 0.5s;
}

.add-serial-number-modal .modal-footer {
    border-top: 1px solid var(--neutral-color4);
}

/* -------------- Assign place-order/ Activity Confirmation ---------------- */
.place-order-confirmation-section {
    min-height: var(--place-order-assign-body-content-height);
    display: grid;
    grid-template-columns: 1fr 5fr 1fr;
}

.place-order-confirmation-section.sidebar-active {
    grid-template-columns: 0.1fr 1fr 0.1fr;
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) {
    min-height: 200px;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 16px var(--border-shadow-color1);
    border-radius: 8px;
    padding: var(--place-order-confirmation-page-content-padding);
    position: relative;
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .download-btn-section {
    position: absolute;
    min-width: var(--download-btn-width);
    right: var(--place-order-confirmation-page-content-padding);
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section {
    width: 100%;
    margin-top: 21px;
    display: grid;
    justify-items: center;
    text-align: center;
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item {
    font: normal normal normal 24px/36px Lato;
    letter-spacing: 0px;
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:first-child {
    color: var(--neutral-color6);
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:nth-child(2) {
    font-weight: bold;
    color: var(--neutral-color7);
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child {
    font: normal normal normal 18px/36px Lato;
    color: var(--neutral-color5);
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section {
    display: grid;
    /* grid-template-columns: repeat(4, 1fr); */
    grid-template-columns: 1fr;
    text-align: center;
    grid-row-gap: 10px;
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section .confirmation-content-id-item {
    padding-left: 10px;
    font: normal normal bold 20px/36px Lato;
    color: var(--call-to-action1);
    border-left: 1px solid var(--neutral-color4);
    cursor: pointer;
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section .confirmation-content-id-item:hover {
    color: var(--call-to-action2);
}

.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section .confirmation-content-id-item:nth-child(4n+1) {
    border-left: 0;
}

/* --------- Mediam Design ----------- */
@media screen and (max-width:1286px) {}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root {
        --place-order-assign-body-content-height: auto;
    }

    .cart-header-nav-section {
        grid-template-columns: 1fr;
    }

    .cart-header-nav-section .cart-header-nav-item-section {
        font: normal normal 18px/22px Lato;
        letter-spacing: 0.18px;
        color: #333333;
    }

    .cart-header-nav-item-section .nav-responsive-2 .nav-link {
        align-items: center;
    }

    .request-stock-card-section,
    .return-stock-card-section {
        min-height: auto;
    }

    .request-stock-card-section .wrapper-request-stock-card-section,
    .return-stock-card-section .wrapper-return-stock-card-section {
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }

    .wrapper-request-stock-card-section .normal-card-item-section:first-child,
    .wrapper-return-stock-card-section .normal-card-item-section:first-child {
        direction: rtl;
        border-right: transparent;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--neutral-color4);
    }

    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2),
    .wrapper-return-stock-card-section .normal-card-item-section:nth-child(2) {
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }

    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .card-item-group,
    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-add-qnt-section,
    .wrapper-return-stock-card-section .normal-card-item-section:nth-child(2) .card-item-group {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        align-items: center;
        padding-bottom: 10px;
    }

    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-add-qnt-section,
    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-add-qnt-section .card-item-qnt-section {
        height: 47px;
    }

    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-add-qnt-section .normal-card-item-qnt-title {
        text-align: start;
    }

    .wrapper-request-stock-card-section .normal-card-item-section:last-child {
        padding-top: 10px;
        border-left: transparent;
        border-top: 1px solid var(--neutral-color4);
    }


    .cart-place-order-section {
        min-height: auto;
    }

    .wrapper-cart-place-order-section {
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 10px;
    }

    .wrapper-cart-place-order-section .cart-place-order-item-group:first-child {
        max-width: 5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /* Return Stock */
    .cart-return-drop-down-section,
    .cart-return-drop-down-section .cart-return-drop-down-item-section:nth-child(2) {
        grid-template-columns: 1fr;
    }

    .cart-return-drop-down-section .cart-return-drop-down-item-section:nth-child(2) {
        grid-row-gap: 10px;
        padding: 0 10px;
    }

    .wrapper-return-stock-card-section .normal-card-item-section:nth-child(2) {
        border-bottom: 1px solid var(--neutral-color4);
    }

    .wrapper-return-stock-card-section .normal-card-item-section:last-child {
        direction: rtl;
        grid-template-columns: 1fr 0.7fr;
        height: 40px;
    }

    .wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child {
        border-right: transparent;
        direction: ltr;
    }

    /* ----- Confiramation ------- */
    .place-order-confirmation-section {
        grid-template-columns: 1fr;
    }

    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section>svg {
        width: 51px;
        height: 51px;
    }

    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) {
        min-height: auto;
    }

    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .download-btn-section {
        border-radius: 50%;
        min-height: auto;
        min-width: auto;
        width: 34px;
        height: 34px;
    }

    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .download-btn-section span {
        display: none;
    }

    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:first-child {
        font: normal normal normal 20px/36px Lato;
    }

    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:nth-child(2) {
        font: normal normal bold 18px/24px Lato;
    }

    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section {
        grid-template-columns: 1fr;
    }

    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section .confirmation-content-id-item {
        border-left: transparent;
    }

    /* -------- Modal ---------- */
    .add-serial-number-modal .modal-dialog .modal-content {
        padding: 0;
    }

    .add-serial-number-modal .modal-dialog .wrapper-modal-header {
        padding: 11px 21px;
        padding-top: 41px !important;
    }

    .add-serial-number-modal .modal-header-title-section .modal-title {
        font: normal normal bold 22px/27px Lato;
    }

    .add-serial-number-modal .modal-body {
        max-height: 100%;
        min-height: auto;
        height: 100%;
    }

    .add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group {
        padding-left: var(--padding-left);
        padding-right: var(--padding-left);
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/CartPage.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,yBAAyB;IACzB,8BAA8B;;IAE9B,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA,qBAAqB;AACrB;IACI,sCAAsC;IACtC,6DAA6D;IAC7D,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,cAAc;;AAElB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,6DAA6D;IAC7D,wCAAwC;IACxC,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,uCAAuC;IACvC,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,+CAA+C;IAC/C,4BAA4B;AAChC;;AAEA,qEAAqE;AACrE;IACI,eAAe;IACf,8CAA8C;IAC9C,4DAA4D;IAC5D,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA,mDAAmD;AACnD,iDAAiD;AACjD;IACI,mCAAmC;IACnC,WAAW;IACX,6DAA6D;IAC7D,iCAAiC;IACjC,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,+CAA+C;IAC/C,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA,gDAAgD;AAChD;;;;;;;;;GASG;AACH;IACI,mCAAmC;IACnC,WAAW;IACX,6DAA6D;;IAE7D,kBAAkB;IAClB,iCAAiC;IACjC,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,WAAW;IACX,mCAAmC;IACnC,aAAa;IACb,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,oBAAoB;AACxB;;;AAGA;IACI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;;AAGA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;;;;AAKA,wDAAwD;AACxD;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,aAAa;IACb,8CAA8C;IAC9C,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,6BAA6B;IAC7B,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,6DAA6D;IAC7D,qDAAqD;IACrD,yCAAyC;IACzC,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,8EAA8E;AAC9E;IACI,yDAAyD;IACzD,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oDAAoD;IACpD,kBAAkB;IAClB,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,2DAA2D;AAC/D;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,6BAA6B;IAC7B,4CAA4C;IAC5C,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA,wCAAwC;AACxC,sCAAsC;;AAEtC,wCAAwC;AACxC;IACI;QACI,8CAA8C;IAClD;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kCAAkC;QAClC,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;;QAEI,cAAc;QACd,yBAAyB;QACzB,oBAAoB;QACpB,8CAA8C;IAClD;;IAEA;;QAEI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;;;QAGI,aAAa;QACb,gCAAgC;QAChC,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,wBAAwB;QACxB,2CAA2C;IAC/C;;;IAGA;QACI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;QAC9B,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA,iBAAiB;IACjB;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,cAAc;QACd,gCAAgC;QAChC,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA,gCAAgC;IAChC;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA,8BAA8B;IAC9B;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,iCAAiC;QACjC,kCAAkC;IACtC;AACJ","sourcesContent":[":root {\r\n    --cart-bannder-height: 100px;\r\n    --cart-card-height: 66px;\r\n    --single-row-height: 69px;\r\n    --add-row-section-height: 45px;\r\n\r\n    --place-order-assign-body-content-height: 35vh;\r\n    --place-order-confirmation-page-content-padding: 24px;\r\n}\r\n\r\n/* ---- Header ---- */\r\n.cart-header-start-section {\r\n    min-height: var(--cart-bannder-height);\r\n    background: var(--neutral-color2) 0% 0% no-repeat padding-box;\r\n    color: var(--neutral-color1);\r\n    width: 100%;\r\n}\r\n\r\n.wrapper-cart-header-section {\r\n    width: 100%;\r\n    min-height: var(--cart-bannder-height);\r\n    padding: var(--body-header-padding);\r\n    padding-bottom: 0;\r\n}\r\n\r\n.wrapper-cart-header-section .breadcrumb .custome-path-active-tab,\r\n.wrapper-cart-header-section .breadcrumb .custome-path-active-tab::before {\r\n    color: var(--neutral-color6);\r\n}\r\n\r\n.cart-header-nav-section {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr 1fr;\r\n    align-items: center;\r\n    border-bottom: 1px solid #CCCCCC;\r\n}\r\n\r\n.cart-header-nav-section .cart-header-nav-item-section {\r\n    font: normal normal 22px/27px Lato;\r\n    letter-spacing: 0.22px;\r\n    color: #333333;\r\n\r\n}\r\n\r\n.cart-header-nav-section .cart-header-nav-item-section:first-child svg {\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.cart-header-nav-section .cart-header-nav-item-section:nth-child(2) {\r\n    display: grid;\r\n    justify-items: center;\r\n}\r\n\r\n.cart-header-nav-section .cart-header-nav-item-section:nth-child(2) .nav-responsive-2 {\r\n    max-width: 420px;\r\n}\r\n\r\n.cart-header-nav-item-section .nav-responsive-2 .nav-link {\r\n    font: normal normal 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n    color: #999999;\r\n}\r\n\r\n.cart-header-nav-item-section .nav-responsive-2 .active {\r\n    color: #333333;\r\n}\r\n\r\n.cart-header-nav-item-section .nav-responsive-2 .nav-link .nav-link-notification-section {\r\n    min-width: 28px;\r\n    height: 28px;\r\n    padding: 0 6px;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--call-to-action1);\r\n    transition: all 0.5s;\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    border-radius: 50%;\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0px;\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.cart-header-nav-item-section .nav-responsive-2 .active .nav-link-notification-section {\r\n    transition: all 0.5s;\r\n    border: 0;\r\n    background: #009DE0 0% 0% no-repeat padding-box;\r\n    color: var(--neutral-color1);\r\n}\r\n\r\n/* ------------------------ Content Section ----------------------- */\r\n.cart-return-drop-down-section {\r\n    padding: 15px 0;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n    background: var(--bg-while-blue) 0% 0% no-repeat padding-box;\r\n    display: grid;\r\n    grid-template-columns: 0.5fr 1.2fr 0.5fr;\r\n}\r\n\r\n.cart-return-drop-down-section .cart-return-drop-down-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n.cart-return-drop-down-section .cart-return-drop-down-item-section:nth-child(2) .card-item-group .custom-drop-down-form-group {\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border-radius: 6px;\r\n}\r\n\r\n.cart-select-all-item-section {\r\n    font: normal normal 14px/15px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--call-to-action1);\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.cart-select-all-item-section:hover {\r\n    color: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n/* ---------------- Card Section ---------------- */\r\n/* -------- Request stock Card Section -------- */\r\n.request-stock-card-section {\r\n    min-height: var(--cart-card-height);\r\n    width: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px #00000029;\r\n    border-radius: 6px;\r\n    padding: 9px 14px 9px 24px;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.request-stock-card-section:hover {\r\n    transform: scale(1.012);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-request-stock-card-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 5fr 0.4fr;\r\n    grid-column-gap: 20px;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:first-child {\r\n    display: grid;\r\n    grid-template-columns: 0.2fr 1fr;\r\n    align-items: center;\r\n    border-right: 1px solid #E6E6E6;\r\n    height: 100%;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:first-child .card-item-value {\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n    color: #009BDF;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: 2fr repeat(3, 0.8fr) 1fr;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .normal-card-item-qnt-title {\r\n    font: normal normal 12px/18px Lato;\r\n    letter-spacing: 0.12px;\r\n    color: #4D4D4D;\r\n    text-align: center\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section {\r\n    display: grid;\r\n    grid-template-columns: 1fr 3fr 1fr;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-input {\r\n    width: 100%;\r\n    min-height: 28px;\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n    border: 1px solid #999999;\r\n    text-align: center;\r\n    font: normal normal bold 14px/15px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: #000000;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn {\r\n    width: 100%;\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n    border: 1px solid #999999;\r\n    border-radius: 4px 0px 0px 4px;\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn:first-child {\r\n    border-right: 0;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn:last-child {\r\n    border-radius: 0px 4px 4px 0px;\r\n    border-left: 0;\r\n}\r\n\r\n.wrapper-request-stock-card-section .normal-card-item-section:last-child {\r\n    border-left: 1px solid #E6E6E6;\r\n    height: 100%;\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n/* -------- Return stock Card Section -------- */\r\n/* .return-stock-details-section{\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    transition: all 0.5s cu;\r\n}\r\n.return-stock-details-section-show{\r\n    height: auto;\r\n    max-height: 9999px;\r\n    transition: all 1s;\r\n} */\r\n.return-stock-card-section {\r\n    min-height: var(--cart-card-height);\r\n    width: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n\r\n    border-radius: 6px;\r\n    box-shadow: 0px 0px 6px #00000029;\r\n    transition: all 0.5s;\r\n    display: grid;\r\n}\r\n\r\n.return-stock-card-section:hover {\r\n    transform: scale(1.012);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-return-stock-card-section {\r\n    padding: 9px 14px 9px 24px;\r\n    box-shadow: 0px 0px 6px #00000029;\r\n    width: 100%;\r\n    min-height: var(--cart-card-height);\r\n    display: grid;\r\n    grid-template-columns: 1fr 5fr 1.7fr;\r\n    grid-column-gap: 20px;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:first-child {\r\n    display: grid;\r\n    grid-template-columns: 0.2fr 1fr;\r\n    align-items: center;\r\n    border-right: 1px solid #E6E6E6;\r\n    height: 100%;\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:first-child .card-item-value {\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n    color: #009BDF;\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: 2fr repeat(3, 0.8fr);\r\n    grid-column-gap: 5px;\r\n}\r\n\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child {\r\n    display: grid;\r\n    grid-template-columns: 1.8fr 0.4fr;\r\n    align-items: center;\r\n    justify-items: center;\r\n    height: 100%;\r\n    grid-column-gap: 3px;\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: grid;\r\n    align-items: center;\r\n    transition: all 0.2s;\r\n    text-align: end;\r\n    font: normal normal bold 14px/18px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group span {\r\n    align-items: center;\r\n    color: var(--indicators-red);\r\n}\r\n\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child {\r\n    border-right: 1px solid #E6E6E6;\r\n    border-left: 1px solid #E6E6E6;\r\n    display: grid;\r\n    cursor: pointer;\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child .card-item-inner {\r\n    text-align: center;\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child svg {\r\n    width: 14px;\r\n    height: 14px;\r\n    margin-left: 10px;\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:last-child {\r\n    justify-items: center;\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child:hover {\r\n    color: var(--call-to-action2);\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child:hover svg line {\r\n    stroke: var(--call-to-action2);\r\n}\r\n\r\n.wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:last-child:hover svg path {\r\n    fill: var(--call-to-action2);\r\n}\r\n\r\n\r\n\r\n\r\n/* -------- Return stock Card Details Section -------- */\r\n.wrapper-return-stock-details-card-section {\r\n    min-height: var(--single-row-height);\r\n    width: 100%;\r\n}\r\n\r\n.wrapper-return-stock-details-card-section .return-stock-card-row-section {\r\n    padding: 8px 20px;\r\n    min-height: var(--single-row-height);\r\n    display: grid;\r\n    grid-template-columns: 0.2fr 1fr 1fr 1fr 0.2fr;\r\n    grid-column-gap: 10px;\r\n    align-items: center;\r\n    justify-items: center;\r\n}\r\n\r\n.wrapper-return-stock-details-card-section .return-stock-card-row-section .card-row-group {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.wrapper-return-stock-details-card-section .return-stock-card-row-section .card-row-group:first-child,\r\n.wrapper-return-stock-details-card-section .return-stock-card-row-section .card-row-group:last-child {\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.wrapper-return-stock-details-card-section .return-stock-card-row-section .card-row-group:first-child {\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.card-row-group .custom-drop-down-form-group {\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n    border-radius: 6px;\r\n}\r\n\r\n.wrapper-return-stock-details-card-section .return-stock-card-row-section:nth-child(odd) {\r\n    background: #F3F3F3 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.add-row-section {\r\n    min-height: var(--add-row-section-height);\r\n    width: 100%;\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--call-to-action1);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.add-row-section svg {\r\n    margin-left: 10px;\r\n}\r\n\r\n.add-row-section:hover,\r\n.add-row-section:hover svg #Group_8724 line,\r\n.add-row-section:hover svg #Ellipse_1157 {\r\n    color: var(--call-to-action2);\r\n    stroke: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.cart-place-order-section {\r\n    position: fixed;\r\n    bottom: 0;\r\n    min-height: 82px;\r\n    width: 100%;\r\n    transition: var(--deault-transition);\r\n    z-index: 1;\r\n}\r\n\r\n.wrapper-cart-place-order-section {\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px -6px 20px var(--border-shadow-color2);\r\n    font: normal normal normal 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color7);\r\n    padding: 15px 24px;\r\n    display: grid;\r\n    align-items: center;\r\n    grid-template-columns: 3fr 1fr;\r\n}\r\n\r\n.wrapper-cart-place-order-section .cart-place-order-item-group:first-child span {\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n}\r\n\r\n.wrapper-cart-place-order-section .cart-place-order-item-group:last-child {\r\n    display: grid;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.cart-return-place-order-section .cart-msg-validation {\r\n    font: normal normal normal 16px/19px Lato;\r\n    text-align: center;\r\n    letter-spacing: 0.16px;\r\n    color: #F44236;\r\n}\r\n\r\n/* -------------- Add Serial Number Modal ---------------- */\r\n.add-serial-number-modal .modal-dialog {\r\n    max-width: 70%;\r\n    margin-top: 8%;\r\n}\r\n\r\n.add-serial-number-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.add-serial-number-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.add-serial-number-modal .modal-header-title-section {\r\n    grid-template-columns: 1fr;\r\n    grid-row-gap: 5px;\r\n}\r\n\r\n.add-serial-number-modal .modal-header-title-section .modal-header-group-section:first-child {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n}\r\n\r\n.add-serial-number-modal .modal-header-title-section .modal-header-group-section:first-child span {\r\n    margin-left: 15px;\r\n    font: normal normal bold 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color5);\r\n}\r\n\r\n.add-serial-number-modal .modal-header-title-section .modal-header-group-section:last-child {\r\n    display: grid;\r\n    grid-template-columns: 1fr 0.5fr;\r\n}\r\n\r\n.add-serial-number-modal .modal-header-title-section .modal-header-group-section:last-child .modal-header-group-item:first-child {\r\n    font: normal normal 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--text-color1);\r\n}\r\n\r\n.add-serial-number-modal .modal-header-title-section .modal-header-group-section:last-child .modal-header-group-item:first-child span {\r\n    font-weight: bold;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.add-serial-number-modal .modal-header-title-section .modal-header-group-section:last-child .modal-header-group-item:last-child {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.add-serial-number-modal .modal-body {\r\n    min-height: 260px;\r\n    max-height: 350px;\r\n    padding-top: 0;\r\n    margin-top: 0;\r\n}\r\n\r\n.add-serial-number-modal .modal-body .wrapper-modal-body {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-row-gap: 0;\r\n}\r\n\r\n.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group {\r\n    display: grid;\r\n    grid-template-columns: 0.1fr 0.8fr 0.1fr;\r\n    grid-column-gap: 10px;\r\n    padding: 10px 0;\r\n}\r\n\r\n.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group:nth-child(odd) {\r\n    background: var(--neutral-color2) 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group .modal-body-group-item {\r\n    display: grid;\r\n    justify-items: center;\r\n    align-items: center;\r\n}\r\n\r\n.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group .modal-body-group-item:nth-child(2) .custom-input-form-group {\r\n    width: 100%;\r\n}\r\n\r\n.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group .modal-body-group-item:last-child {\r\n    cursor: pointer;\r\n}\r\n\r\n.add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group .modal-body-group-item:last-child:hover svg path {\r\n    fill: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.add-serial-number-modal .modal-footer {\r\n    border-top: 1px solid var(--neutral-color4);\r\n}\r\n\r\n/* -------------- Assign place-order/ Activity Confirmation ---------------- */\r\n.place-order-confirmation-section {\r\n    min-height: var(--place-order-assign-body-content-height);\r\n    display: grid;\r\n    grid-template-columns: 1fr 5fr 1fr;\r\n}\r\n\r\n.place-order-confirmation-section.sidebar-active {\r\n    grid-template-columns: 0.1fr 1fr 0.1fr;\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) {\r\n    min-height: 200px;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 2px 16px var(--border-shadow-color1);\r\n    border-radius: 8px;\r\n    padding: var(--place-order-confirmation-page-content-padding);\r\n    position: relative;\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .download-btn-section {\r\n    position: absolute;\r\n    min-width: var(--download-btn-width);\r\n    right: var(--place-order-confirmation-page-content-padding);\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section {\r\n    width: 100%;\r\n    margin-top: 21px;\r\n    display: grid;\r\n    justify-items: center;\r\n    text-align: center;\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item {\r\n    font: normal normal normal 24px/36px Lato;\r\n    letter-spacing: 0px;\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:first-child {\r\n    color: var(--neutral-color6);\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:nth-child(2) {\r\n    font-weight: bold;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child {\r\n    font: normal normal normal 18px/36px Lato;\r\n    color: var(--neutral-color5);\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section {\r\n    display: grid;\r\n    /* grid-template-columns: repeat(4, 1fr); */\r\n    grid-template-columns: 1fr;\r\n    text-align: center;\r\n    grid-row-gap: 10px;\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section .confirmation-content-id-item {\r\n    padding-left: 10px;\r\n    font: normal normal bold 20px/36px Lato;\r\n    color: var(--call-to-action1);\r\n    border-left: 1px solid var(--neutral-color4);\r\n    cursor: pointer;\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section .confirmation-content-id-item:hover {\r\n    color: var(--call-to-action2);\r\n}\r\n\r\n.place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section .confirmation-content-id-item:nth-child(4n+1) {\r\n    border-left: 0;\r\n}\r\n\r\n/* --------- Mediam Design ----------- */\r\n@media screen and (max-width:1286px) {}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root {\r\n        --place-order-assign-body-content-height: auto;\r\n    }\r\n\r\n    .cart-header-nav-section {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .cart-header-nav-section .cart-header-nav-item-section {\r\n        font: normal normal 18px/22px Lato;\r\n        letter-spacing: 0.18px;\r\n        color: #333333;\r\n    }\r\n\r\n    .cart-header-nav-item-section .nav-responsive-2 .nav-link {\r\n        align-items: center;\r\n    }\r\n\r\n    .request-stock-card-section,\r\n    .return-stock-card-section {\r\n        min-height: auto;\r\n    }\r\n\r\n    .request-stock-card-section .wrapper-request-stock-card-section,\r\n    .return-stock-card-section .wrapper-return-stock-card-section {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n\r\n    .wrapper-request-stock-card-section .normal-card-item-section:first-child,\r\n    .wrapper-return-stock-card-section .normal-card-item-section:first-child {\r\n        direction: rtl;\r\n        border-right: transparent;\r\n        padding-bottom: 10px;\r\n        border-bottom: 1px solid var(--neutral-color4);\r\n    }\r\n\r\n    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2),\r\n    .wrapper-return-stock-card-section .normal-card-item-section:nth-child(2) {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n\r\n    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .card-item-group,\r\n    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-add-qnt-section,\r\n    .wrapper-return-stock-card-section .normal-card-item-section:nth-child(2) .card-item-group {\r\n        display: grid;\r\n        grid-template-columns: 0.5fr 1fr;\r\n        align-items: center;\r\n        padding-bottom: 10px;\r\n    }\r\n\r\n    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-add-qnt-section,\r\n    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-add-qnt-section .card-item-qnt-section {\r\n        height: 47px;\r\n    }\r\n\r\n    .wrapper-request-stock-card-section .normal-card-item-section:nth-child(2) .normal-card-item-add-qnt-section .normal-card-item-qnt-title {\r\n        text-align: start;\r\n    }\r\n\r\n    .wrapper-request-stock-card-section .normal-card-item-section:last-child {\r\n        padding-top: 10px;\r\n        border-left: transparent;\r\n        border-top: 1px solid var(--neutral-color4);\r\n    }\r\n\r\n\r\n    .cart-place-order-section {\r\n        min-height: auto;\r\n    }\r\n\r\n    .wrapper-cart-place-order-section {\r\n        grid-template-columns: 1fr 1fr;\r\n        grid-column-gap: 10px;\r\n    }\r\n\r\n    .wrapper-cart-place-order-section .cart-place-order-item-group:first-child {\r\n        max-width: 5rem;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    /* Return Stock */\r\n    .cart-return-drop-down-section,\r\n    .cart-return-drop-down-section .cart-return-drop-down-item-section:nth-child(2) {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .cart-return-drop-down-section .cart-return-drop-down-item-section:nth-child(2) {\r\n        grid-row-gap: 10px;\r\n        padding: 0 10px;\r\n    }\r\n\r\n    .wrapper-return-stock-card-section .normal-card-item-section:nth-child(2) {\r\n        border-bottom: 1px solid var(--neutral-color4);\r\n    }\r\n\r\n    .wrapper-return-stock-card-section .normal-card-item-section:last-child {\r\n        direction: rtl;\r\n        grid-template-columns: 1fr 0.7fr;\r\n        height: 40px;\r\n    }\r\n\r\n    .wrapper-return-stock-card-section .normal-card-item-section:last-child .card-item-group:first-child {\r\n        border-right: transparent;\r\n        direction: ltr;\r\n    }\r\n\r\n    /* ----- Confiramation ------- */\r\n    .place-order-confirmation-section {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section>svg {\r\n        width: 51px;\r\n        height: 51px;\r\n    }\r\n\r\n    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) {\r\n        min-height: auto;\r\n    }\r\n\r\n    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .download-btn-section {\r\n        border-radius: 50%;\r\n        min-height: auto;\r\n        min-width: auto;\r\n        width: 34px;\r\n        height: 34px;\r\n    }\r\n\r\n    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .download-btn-section span {\r\n        display: none;\r\n    }\r\n\r\n    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:first-child {\r\n        font: normal normal normal 20px/36px Lato;\r\n    }\r\n\r\n    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:nth-child(2) {\r\n        font: normal normal bold 18px/24px Lato;\r\n    }\r\n\r\n    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .place-order-confirmation-section .place-order-confirmation-item-section:nth-child(2) .place-order-confirmation-content-section .confirmation-content-item:last-child .confirmation-content-item-id-section .confirmation-content-id-item {\r\n        border-left: transparent;\r\n    }\r\n\r\n    /* -------- Modal ---------- */\r\n    .add-serial-number-modal .modal-dialog .modal-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .add-serial-number-modal .modal-dialog .wrapper-modal-header {\r\n        padding: 11px 21px;\r\n        padding-top: 41px !important;\r\n    }\r\n\r\n    .add-serial-number-modal .modal-header-title-section .modal-title {\r\n        font: normal normal bold 22px/27px Lato;\r\n    }\r\n\r\n    .add-serial-number-modal .modal-body {\r\n        max-height: 100%;\r\n        min-height: auto;\r\n        height: 100%;\r\n    }\r\n\r\n    .add-serial-number-modal .modal-body .wrapper-modal-body .mobal-body-section-group {\r\n        padding-left: var(--padding-left);\r\n        padding-right: var(--padding-left);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
